import { HotelTourModel } from 'api-hooks/tour/tour-list/hotel/model';
import classNames from 'classnames';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'components/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import HotalTourSection from '.';
import styles from '../styles.module.css';

interface Props {
  hotel?: HotelTourModel[];
}

export function HotelTab(props: Props) {
  const { t } = useTranslation();
  const { hotel } = props;
  const { editable } = useFormState();
  return (
    <div className={classNames(styles.padtb16, styles.fullFlex)}>
      {(!editable && !!hotel?.length) || editable ? (
        <HotalTourSection />
      ) : (
        <>{t('common:no_hotel_set_yet')}</>
      )}
      <SeparatorVertical $margin={24} />
    </div>
  );
}
